<template>
    <div>
        <!-- <mt-field :label="model.caption" :value="displayValue" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign"></mt-field> -->
        <mt-cell :title="model.caption" :readonly="param.readonly" v-if="param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <div class="em-select-value mt-color-grey-lv3">
                <template>{{displayValue}}</template>
            </div>
        </mt-cell>
        <mt-cell :title="model.caption" is-link @click.native="handleOpenPicker" :disabledcolor="param.disabled" :required="param.required" v-if="!param.readonly" :titlewidth="titlewidth" :value-align="textalign">
            <span :class="[{'mt-color-grey-lv3':displayValue ==='请选择' }]">{{displayValue}}</span>
        </mt-cell>
        <mt-datetime-picker ref="picker" :min-date="minDate" :max-date="maxDate" :type="type" :value="currrentValue" @confirm="handleConfirm" class="emapm-date-picker" v-if="!param.readonly">
        </mt-datetime-picker>
        
    </div>
</template>
<script>
import { Utils } from '../formUtils.js';
export default {

    name: 'emDateTimePicker',

    props: {
        model: {
            type: Object,
            default: function() {
                return {};
            }
        },
        value: null,
        titlewidth:{
            type: String,
            default: function() {
                return '';
            }
        },
        textalign:{
            type: String,
            default: function() {
                return '';//flex-start
            }
        }
    },

    data() {
        return {
            minDate: new Date(new Date().getFullYear() - 100, 0, 1),
            maxDate: new Date(new Date().getFullYear() + 30, 11, 31)
        };
    },

    computed: {
        type() {
            if (this.model.xtype === 'date-local') {
                return 'date';
            }
            if (this.model.xtype === 'date-ym') {
                return 'dateym';
            }
            if (this.model.xtype === 'date-full') {
                return 'datetime';
            }
            return 'time';
        },
        param() {
            return this.model.initParam;
        },
        pickerFormat() {
            if (this.type === 'date') {
                return 'yyyy-MM-dd';
            }
            if (this.type === 'dateym') {
                return 'yyyy-MM';
            }
            if (this.type === 'datetime') {
                return 'yyyy-MM-dd HH:mm';
            }
            return 'HH:mm';
        },
        valueFormat() {
            return this.model.format || this.pickerFormat;
        },
        currrentValue() {
            //debugger
            if (this.value) {
                if (this.type !== 'time') {
                    return Utils.parseDate(this.value, this.valueFormat);
                }else {
                    return this.value;
                }
            }else {
                if(this.type == 'time'){
                    return "00:00";
                }else {
                    return new Date();
                }
            } 
        },
        displayValue() {
            if (this.value) {
                if(this.type !== 'time'){
                    return Utils.formatDate(Utils.parseDate(this.value, this.valueFormat), this.pickerFormat) 
                }else {
                    return this.value;
                }
            }
            if (this.param.readonly) {
                return this.value;
            }
            return '请选择';
        }
    },

    watch: {
        minDate(val) {
            if ((+val) > (+this.currrentValue)) {
                this.handleConfirm(val);
            }
        },
        maxDate(val) {
            if ((+val) < (+this.currrentValue)) {
                this.handleConfirm(val);
            }
        },
        value(val){
            this.currrentValue = val;
        }
    },

    created() {
        if (this.param.min) {
            this.setMinDate(this.param.min);
        }
        if (this.param.max) {
            this.setMaxDate(this.param.max);
        }
    },

    methods: {
        handleOpenPicker() {
            if (this.param.disabled || this.param.readonly) {
                return;
            }
            this.$refs.picker.open();
        },
        handleConfirm(val) {
            let value = val;
            if (val instanceof Date) {
                value = Utils.formatDate(val, this.valueFormat);
            } else {
                if (this.valueFormat !== this.pickerFormat) {
                    value = Utils.formatDate(Utils.parseDate(val, this.pickerFormat), this.valueFormat);
                }
            }
            this.$refs.picker.close();
            if(Number(value.split(':')[0])<10){
               this.$emit('input', '0'+ value);
            }else {
               this.$emit('input', value);
            }
        },
        setMinDate(date) {
            if (date instanceof Date) {
                this.minDate = date;
            } else {
                this.minDate = Utils.parseDate(date, this.valueFormat);
            }
        },
        setMaxDate(date) {
            if (date instanceof Date) {
                this.maxDate = date;
            } else {
                this.maxDate = Utils.parseDate(date, this.valueFormat);
            }
        }
    }
};
</script>
<style lang="css">
.emapm-date-picker .mint-picker-column__frame {
    position: absolute;
}
</style>


// WEBPACK FOOTER //
// emDateTimePicker.vue?1aa7fb5c